<template>
    <div class="header">
        <div>
            <img src="@/assets/img/logo.png" class="logo" /> 
            <span>全场景编辑器</span> 
        </div>
        <div>
            <span @click.stop="save(0)"><i class="iconfont iconbaocun"></i> 保存 </span>
            <span @click.stop="save(1)"><i class="iconfont iconlingcunwei"></i> 另存为 </span>
            <span @click.stop="save(3)"><i class="iconfont iconyulan"></i> 预览 </span>
            <span @click.stop="exit"><i class="iconfont icontuichu"></i> 退出</span>
        </div>
    </div>
</template>

<script>
import { ResponseCode } from "@/utils/axios";
import BusEvent from "@/busEvent"
import Cookie from "js-cookie"

export default {

    data(){
        return {

        }
    },

    props: {

    },

    computed: {
        viewer(){
            return window.viewer
        }
    },

    mounted(){
        window.addEventListener( 'click', this.verifyLogin )
    },

    beforeDestroy(){
        window.removeEventListener( 'click', this.verifyLogin )
    },

    methods: {
        /**
         * 保存
         */
        save( status ){
            this.$mr_confirm( `是否${status == 1 ? '另存' : '保存'}当前场景？`, () => {
                let data = Object.create(null)
                var modelDatas = this.viewer.resourceManager.export()
                data.modelDatas = JSON.stringify( modelDatas )
                data.cameraData = JSON.stringify( this.viewer.cameraData )
                data.hotspotData = this.exportHotSpot()
                //保存名称、封面等信息
                data = Object.assign( data, this.$parent.$refs.menu.modelInfo )
                data.userId = Cookie.get('loginId')
                data.id = this.$route.query.id || ''
                data.released = true
                if( status === 1 ){
                    delete data.id
                }
                this.axios.post( '/api-application/interiorScene/saveOrUpdate', data ).then(res => {
                    if( res.resp_code == ResponseCode.SUCCESS ){
                        if( status == 3 ){
                            window.open( `/3d/preview?id=${res.datas}` )
                        }
                        if( status == 1 ){
                            this.$router.replace({ path: `/scene/editor?id=${res.datas}` })
                            location.reload()
                        }
                        if( status == 0 ){
                            this.$router.replace({ path: `/scene/editor?id=${res.datas}` })
                            location.reload()
                        }
                    }else{
                        this.$message.warning( res.resp_msg )
                    }
                })
            })
        },

        /**
         * 退出编辑器
         */
        exit(){
            this.$mr_confirm( '确认退出吗？', () => {
                window.opener = null
                window.open('_blank','_self')
                window.close()
            })
        },

        /**
         * 校验用户是否登陆
         */
        verifyLogin(){
            if( !this.$store.state.login.loginId || !Cookie.get('loginId') ){
                this.$root.loginVisible = true
            }
        },  

        /**
         * 导出热点数据
         */
        exportHotSpot(){
            var arr = this.viewer.hotSpotManager.defaultLayer.spots.map( item => {
                if( item.objectId ){
                    item.userData.position = this.viewer.root.getObjectById( item.objectId ).localToWorld( item.position ).toArray()
                }
                return item.userData
            })
            return JSON.stringify( arr )
        }
    }
}


</script>

<style lang="scss" scoped>
.header{
    background-color: #1458EA; height: 60px; display: flex; justify-content: space-between; align-items: center;
    >div:nth-child(1){
        display: flex; align-items: center; height: 100%;
        img{ width: 91px; height: 29px; padding: 0 20px; border-right: 1px solid rgba(255,255,255,0.2); margin-right: 10px; }
        span{ font-size: 18px; color: #FFF; }
    }
    >div:nth-child(2){
        display: flex; align-items: center; height: 100%;
        span{
            .iconfont{ font-size: 18px; margin: 0 3px; }
            color: #FFF; padding: 0 20px; border-right: 1px solid rgba(255,255,255,0.2); font-size: 14px; cursor: pointer; 
        }
    }
}
</style>